export const EVALUATION_CLIENT_STAGE_ID = 1;
export const SETUP_CLIENT_STAGE_ID = 2;
export const DEMO_CLIENT_STAGE_ID = 3;
export const TRAINING_CLIENT_STAGE_ID = 4;
export const PAYMENT_CLIENT_STAGE_ID = 5;

var clientStages = [
    {id:1,name:"Evaluation"},
    {id:2,name:"Setup"},
    {id:3,name:"Demo"},
    {id:4,name:"Training"},
    {id:5,name:"Payment"}
];

export default clientStages;
export function getStageFromId(id){
	var stage = clientStages.find(curr => {
		return curr.id === id;
	});

	return stage ? stage.name : null;
}


// WEBPACK FOOTER //
// ./app/constants/clientStages.js